var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-baby",
    width: 24,
    height: 24,
    viewBox: "-2 -2 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1625 0.000152588L15.2625 13.8127C14.8875 16.2877 12.7 18.1502 10.175 18.1502H0V20.0002H10.1625C13.65 20.0002 16.575 17.5127 17.125 14.0627L20 0.000152588H18.1625ZM2.68752 15.5752H11.5875C12.7625 15.5752 13.7625 14.7627 14.0125 13.6252L16.0001 3.45017C16.0751 3.08767 16.0001 2.5001 15.5001 2.00005C14.5001 1.00009 12.975 0.17517 11.525 3.45017C11.525 3.45017 10.1625 5.73767 11.525 10.5377C11.525 10.5377 12.2125 13.0752 8.61252 12.4252C8.61252 12.4252 3.15002 10.2002 2.30002 15.1252C2.26252 15.3627 2.45002 15.5752 2.68752 15.5752ZM4.21249 16.2752H11.0875C11.2601 16.2752 11.4 16.4151 11.4 16.5877V17.2127C11.4 17.3853 11.2601 17.5252 11.0875 17.5252H4.21249C4.03991 17.5252 3.89999 17.3853 3.89999 17.2127V16.5877C3.89999 16.4151 4.03991 16.2752 4.21249 16.2752Z",
    fill: "#7E8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildSeat);
export default __webpack_public_path__ + "static/media/child-seat.909fbe30.svg";
export { ForwardRef as ReactComponent };